"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useAwaitableNavigate_exports = {};
__export(useAwaitableNavigate_exports, {
  useAwaitableNavigate: () => useAwaitableNavigate
});
module.exports = __toCommonJS(useAwaitableNavigate_exports);
var import_react = require("@remix-run/react");
var import_react2 = __toESM(require("react"));
const useAwaitableNavigate = () => {
  const navigate = (0, import_react.useNavigate)();
  const location = (0, import_react.useLocation)();
  const resolveFunctionsRef = import_react2.default.useRef([]);
  const resolveAll = () => {
    resolveFunctionsRef.current.forEach((resolve) => resolve());
    resolveFunctionsRef.current.splice(0, resolveFunctionsRef.current.length);
  };
  import_react2.default.useEffect(() => {
    resolveAll();
  }, [location]);
  return (to, opts) => {
    return new Promise((res) => {
      resolveFunctionsRef.current.push(res);
      navigate(to, opts);
    });
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useAwaitableNavigate
});
//# sourceMappingURL=useAwaitableNavigate.js.map